export { default } from './RelatedMaterials';



// WEBPACK FOOTER //
// ./src/components/RelatedMaterials/index.js